import isEmpty from 'is-empty';
import {
  ADD_BANK_ACCOUNT,
  ADD_BANK_ACCOUNT_ERROR,
  DELETE_ADD_BANK_ACCOUNT_ERROR,
  ADD_BANK_ACCOUNT_LOADING
} from '../../actions/types';

const initialState = {
  success: false,
  addBank: {},
  error: '',
  loading: false,
};

const addBankDetails = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BANK_ACCOUNT:
      return {
        ...state,
        success: !isEmpty(action.addBank),
        addBank: action.addBank
      };
    case ADD_BANK_ACCOUNT_ERROR:
      return {
        ...state,
        success: false,
        error: action.error,
        loading: false
      };
    case DELETE_ADD_BANK_ACCOUNT_ERROR:
      return {
        error: ''
      };
    case ADD_BANK_ACCOUNT_LOADING:
      return {
        ...state,
        loading: true
      };
    default: return state;
  }
};

export default addBankDetails;
